/** @clearscore/helpers.can-use-dom v1.21.8: 2023-3-8 15:45 (assemble v5.5.3) **/
var index = function index() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
};
export { index as default };